module.exports = __webpack_public_path__ + "static/BeCause-946e9290dd88efb786a2d67c4f6bfce0.jpg";